var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDfh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3534 0L14.8706 8.68807C3.90786 9.90412 0.806674 22.2118 11.38 20.8984C-3.51233 25.0239 -4.66171 7.16802 13.143 7.60028L17.3534 0Z",
    fill: "#E54E37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7553 0.163818L14.6558 14.3336C21.0753 3.20156 27.8063 13.0249 9.79395 26.9999C33.8341 14.5141 26.0929 -2.60553 17.8915 8.68801L18.7553 0.163818Z",
    fill: "#0A2240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfh);
export default __webpack_public_path__ + "static/media/dfh.f4a7a7a36800ef1be2141f4a658936d6.svg";
export { ForwardRef as ReactComponent };